"use client";

import { LOGO_DARK } from "@/app/(protected)/config/constants";
import { styled } from "@mui/material";
import Link from "next/link";
import { useState } from "react";

type Props = {
  href?: string;
};

const AuthLogo = ({ href = "/" }: Props) => {
  const [imgError, setImgError] = useState(false);

  const LinkStyled = styled(Link)(() => ({
    height: 40,
    width: 160,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }));

  return (
    <LinkStyled href={href}>
      <img
        src={imgError ? "/images/system/default/logo-dark.svg" : LOGO_DARK}
        alt="JKL ERP"
        height={40}
        width={150}
        style={{ objectFit: "contain" }}
        onError={() => setImgError(true)}
      />
    </LinkStyled>
  );
};

export default AuthLogo;
